var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { themeLss } from "../../lss";
import styled from "../../styled";
import { Flex } from '../Box';
export var FormGroupMessage = styled.p(themeLss(function (_a) {
    var isInvalid = _a.isInvalid, disabled = _a.disabled;
    return ({
        mt: 'sm',
        mb: 'none',
        color: disabled ? 'gray700' : isInvalid ? 'danger500' : 'inherit',
        textScale: 'control'
    });
}));
export var Label = styled.label(themeLss(function (_a) {
    var inline = _a.inline, required = _a.required;
    return ({
        color: 'gray900',
        mr: 'md',
        mb: inline ? 0 : 'md',
        '&:after': required
            ? {
                content: '*',
                color: 'danger500',
                fontWeight: 'bold',
                alignAelf: 'flex-start',
                ml: 'xxs'
            }
            : undefined
    });
}));
var FormControlWrapper = styled(Flex)(function (_a) {
    var isInline = _a.isInline;
    return "\n  " + (isInline
        ? "\n          display: inline-flex;\n          flex-direction: row;\n          align-items: center;\n          width: 100%;\n        "
        : "\n          flex-direction: column;\n          flex-shrink: 0;\n        ") + "\n";
});
export var FormGroup = function (_a) {
    var isInvalid = _a.isInvalid, isInline = _a.isInline, id = _a.id, label = _a.label, required = _a.required, descriptionId = _a.descriptionId, description = _a.description, error = _a.error, children = _a.children, disabled = _a.disabled, labelLss = _a.labelLss, lss = _a.lss, _b = _a.showValidationToolTip, showValidationToolTip = _b === void 0 ? false : _b;
    var message = (isInvalid && !showValidationToolTip && error) || description;
    return (React.createElement(FormControlWrapper, { isInline: isInline, "data-invalid": isInvalid, lss: __assign({ pb: 'xl' }, lss) },
        label && (React.createElement(Label, { id: id + "-label", htmlFor: id, inline: isInline, required: required, lss: labelLss }, label)),
        children,
        !!message && (React.createElement(FormGroupMessage, { disabled: disabled, isInvalid: isInvalid, id: descriptionId }, message))));
};
//# sourceMappingURL=FormGroup.js.map